import { render, staticRenderFns } from "./roundedButton.vue?vue&type=template&id=c716dcbe&scoped=true&"
import script from "./roundedButton.vue?vue&type=script&lang=js&"
export * from "./roundedButton.vue?vue&type=script&lang=js&"
import style0 from "./roundedButton.vue?vue&type=style&index=0&id=c716dcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c716dcbe",
  null
  
)

export default component.exports